export type ProductRecommendation = 'yes' | 'no' | '';

export interface WriteReviewFormFields {
  readonly rating: number;
  readonly reviewText: string;
  readonly reviewTitle: string;
  readonly nickname: string;
  readonly email: string;
  readonly recommendation: ProductRecommendation;
  readonly photos: File[];
  readonly termsAccepted: boolean;
  // Account-specific fields Bazaarvoice reports via getProductReviewForm (e.g. custom
  // ContextDataValue_* questions), keyed by their Bazaarvoice field id. Optional fields may be
  // unset. Boolean values come from BooleanInput fields, rendered as a checkbox bound directly
  // to Formik state; every other extra-field type is a plain string.
  readonly extraFields: Record<string, string | boolean | undefined>;
}

export const initialWriteReviewFormValues: WriteReviewFormFields = {
  rating: 0,
  reviewText: '',
  reviewTitle: '',
  nickname: '',
  email: '',
  recommendation: '',
  photos: [],
  termsAccepted: false,
  extraFields: {}
};
